export default __webpack_public_path__ + "b5c70ac183578d148b3819b0df37b5be.png";